// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FeAY","label":"styles_label__1z5PE"};